<awair-header></awair-header>
<div class="header-pad" style="margin-top: 56px;"></div>
<router-outlet></router-outlet>